import React from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import StreamSetupPopup from "../settings-common-components/StreamSetupPopup";
import { StackActions, useNavigation } from "@react-navigation/native";
import { AppImages } from "../../utility/AppImages";

const StreamSetupHeader = ({ eventDetail }) => {
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [showPopup, setShowPopup] = React.useState(false);
  // No longer need connection logic here - handled by context automatically

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <View style={{ flexDirection: "row", gap: 10, alignItems: "center" }}>
        <TouchableOpacity
          onPress={() => {
            navigation.dispatch(StackActions.pop());
          }}
        >
          <Image
            source={AppImages.icArrowLeft}
            style={{ height: 24, width: 24 }}
            resizeMode="contain"
          />
        </TouchableOpacity>

        <Text
          style={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? AppFontStyle.BOLD_ANYBODY_16
              : AppFontStyle.BOLD_ANYBODY_20
          }
        >
          Stream Setup
        </Text>
      </View>

      {deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? (
        <>
          <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
            <Text style={AppFontStyle.SEMIBOLD_ANYBODY_14}>
              {eventDetail?.eventTitle}
            </Text>
            <TouchableOpacity
              onPress={() => {
                setShowPopup(true);
              }}
              style={{
                paddingVertical: 10,
                paddingHorizontal: 14,
                borderWidth: 2,
                borderColor: AppColors.appViolentColor_6D08C3,
                borderRadius: 8,
                backgroundColor: AppColors.appViolentColor_6D08C3,
              }}
            >
              <Text style={AppFontStyle.SEMIBOLD_ANYBODY_12}>
                OBS Controls Panel
              </Text>
            </TouchableOpacity>
          </View>

          <StreamSetupPopup
            screen="LiveStream"
            showPopup={showPopup}
            setShowPopup={setShowPopup}
          />
        </>
      ) : (
        <>
          <View style={{ flexDirection: "row", alignItems: "center", gap: 15 }}>
            <Text style={AppFontStyle.BOLD_ANYBODY_20}>
              {eventDetail?.eventTitle}
            </Text>
          </View>
        </>
      )}
    </View>
  );
};

export default StreamSetupHeader;
